
import React, { useEffect, useState } from 'react';

interface HeartbeatAnimationProps {
  count?: number;
  className?: string;
}

export const HeartbeatAnimation: React.FC<HeartbeatAnimationProps> = ({ 
  count = 3,
  className = "" 
}) => {
  const [pulses, setPulses] = useState<Array<{
    id: number;
    top: string;
    left: string;
    scale: number;
    delay: number;
  }>>([]);

  useEffect(() => {
    // Generate pulses
    const generatedPulses = Array.from({ length: count }).map((_, index) => ({
      id: index,
      top: `${20 + Math.random() * 60}%`,
      left: `${20 + Math.random() * 60}%`,
      scale: Math.random() * 0.5 + 0.5, // Scale between 0.5 and 1
      delay: index * 2 // Stagger the pulses
    }));
    
    setPulses(generatedPulses);
  }, [count]);

  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none z-0 ${className}`}>
      {pulses.map((pulse) => (
        <div
          key={pulse.id}
          className="heartbeat-pulse"
          style={{
            top: pulse.top,
            left: pulse.left,
            transform: `scale(${pulse.scale})`,
            animationDelay: `${pulse.delay}s`
          }}
        />
      ))}
    </div>
  );
};
